import type { ReactNode } from "react";

/** Centered empty / error placeholder for the list + thread. */
export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center px-8 py-12 gap-3 h-full">
      {icon && (
        <div className="text-slate-600 [&>svg]:w-8 [&>svg]:h-8" aria-hidden>
          {icon}
        </div>
      )}
      <div className="text-sm font-medium text-slate-300">{title}</div>
      {hint && <div className="text-xs text-slate-500 max-w-[16rem]">{hint}</div>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
